import { ChangeDetectionStrategy, Component } from "@angular/core";
import { InputGroup } from "primeng/inputgroup";

@Component({
    selector: "kno2-input-group",
    imports: [InputGroup],
    template: `
        <p-inputgroup>
            <ng-content />
        </p-inputgroup>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputGroupComponent {}
